import type { ActivityDefinition } from "@medplum/fhirtypes";
import { type AddExamFromVisitParams, addExamFromVisitExternalInputSchema } from "@repo/api/schemas";
import type { Collection } from "@tanstack/db";
import { defineWrite, type WriteOptions } from "../actions/define-write";
import type { AppointmentRow, ObservationRow } from "../fhir/types";
import { optimisticExam } from "./_exam-optimistic";

export function createAddExamFromVisitAction(deps: {
  appointments: () => Collection<AppointmentRow, string>;
  exams: () => Collection<ObservationRow, string>;
  definitions: () => readonly ActivityDefinition[];
  mutate: (input: AddExamFromVisitParams, options: WriteOptions) => Promise<unknown>;
}) {
  return defineWrite<AddExamFromVisitParams>({
    optimistic: (params) => {
      const input = addExamFromVisitExternalInputSchema.parse(params);
      const visit = deps.appointments().get(input.visitId);
      if (!visit?.patientId) throw new Error(`Visit '${input.visitId}' is not loaded`);
      deps.exams().insert(optimisticExam({ ...input, patientId: visit.patientId }, deps.definitions()));
    },
    persist: (params, options) => deps.mutate(addExamFromVisitExternalInputSchema.parse(params), options),
  });
}
